// DS: i1.1
import React from 'react';
import IconWrap from '../IconWrap';
const DeviantArtLogo = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        width: "0",
        height: "0",
        viewBox: "0 0 24 24",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M14.475 2l-.352.355-1.664 3.17-.522.353H6v4.84h3.264l.29.352L6 17.862v3.525h3.525l.352-.354 1.663-3.17.523-.353H18v-4.841h-3.264l-.29-.354L18 5.525V2z"
    }))));
DeviantArtLogo.displayName = 'DeviantArtLogo';
export default DeviantArtLogo;
